var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillSelfGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8187_42466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 36,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33594H30",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97656 25.0026L15.0116 12.5351V3.33594H25.0199V12.5351L31.0332 25.0026",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49227 36.3945C5.84117 36.0793 5.34193 35.5184 5.10438 34.8351C4.86684 34.1519 4.91044 33.4022 5.2256 32.7511L8.9781 25.0003C8.9781 25.0003 14.9973 29.167 19.9973 25.0003C24.9973 20.8336 31.0356 25.0003 31.0356 25.0003L34.7773 32.7545C34.9779 33.1703 35.0696 33.6303 35.0439 34.0913C35.0182 34.5523 34.8759 34.9992 34.6303 35.3902C34.3847 35.7812 34.0439 36.1034 33.6398 36.3267C33.2357 36.55 32.7815 36.6671 32.3198 36.667H7.6806C7.26894 36.667 6.8631 36.5736 6.49227 36.3945Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8187_42466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "#807F7E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillSelfGrey);
export default __webpack_public_path__ + "static/media/skill-self-grey.3d67b9c3b6e2a39f051db69dc98c16ba.svg";
export { ForwardRef as ReactComponent };